import { useCallback, useState } from 'react';

/**
 * Hook to manage pagination state for server-side paginated TanStack tables.
 *
 * @param {Object} options
 * @param {Function} [options.onPageChange] - Optional side effect called with the resolved pagination state
 *   ({ pageSize, pageIndex }) whenever pagination changes. Useful for syncing to URL params, etc.
 */
export const usePagination = ({ onPageChange } = {}) => {
  const [pagination, setPagination] = useState({
    pageSize: 20,
    pageIndex: 0,
  });
  const { pageSize, pageIndex } = pagination;

  const handlePaginationChange = useCallback(
    (updater) => {
      setPagination((prev) => {
        const next = typeof updater === 'function' ? updater(prev) : updater;
        if (onPageChange) {
          onPageChange(next);
        }
        return next;
      });
    },
    [onPageChange],
  );

  return {
    limit: pageSize,
    onPaginationChange: onPageChange ? handlePaginationChange : setPagination,
    pagination,
    offset: pageSize * pageIndex,
  };
};
